module.exports = __webpack_public_path__ + "img/ryuma.985731a8.png";